const _state = {
    loading: false,
    isNavOpen: false,
    isMobileDensity: false,
  }
  
  export const initialState = () => _state
  
  export const state = initialState()
  